import React from 'react';

import { Collapse, CollapseProps, Flex, Typography } from 'antd';

const { Text } = Typography;

const faqItemsStyles = {
  header: {
    padding: '0',
  },
  body: {
    padding: '.5rem',
  },
};

const FAQItem = ({ items }: { items: string[] }) => (
  <ul style={{ listStyleType: 'disc', marginLeft: '1.5rem' }}>
    {items.map((item: string, index: number) => (
      <li key={index}>
        <Text>{item}</Text>
      </li>
    ))}
  </ul>
);

const faqItems: CollapseProps['items'] = [
  {
    key: '1',
    label: 'What will happen if I start the closure procedure?',
    children: (
      <Flex vertical align="flex-start" gap=".5rem">
        <Text>
          There are 3 steps in order to close an organisation and anonymize its
          data.
        </Text>
        <Text>1. First, you “start the closure procedure”:</Text>
        <FAQItem
          items={[
            'Users will be notified about the organisation’s closure',
            'They will be also kindly asked to return all their LivingPackets products back to us',
          ]}
        />
        <Text>2. Secondly, you finalize and close an organisation:</Text>
        <FAQItem
          items={[
            '“Close this organisation” button starts data anonymisation process that will take action in 3 months',
            'During next 3 months after closing organisation, users will lose all access to LivingPackets WebApp. But they will still be able to ask their data or to be reconnected.',
          ]}
        />
        <Text>
          3. Thirdly, 3 months after closing organisation, an automated data
          anonymization process starts:
        </Text>
        <FAQItem
          items={[
            'All users of this organisation will definitly lose access to LivingPackets WebApp',
            'LivingPackets will lose all data on this organisation',
            'Back-office will not be able to reactivate the organisation’s account.',
          ]}
        />
      </Flex>
    ),
    styles: faqItemsStyles,
  },
  {
    key: '2',
    label: 'What you need in order to start the closure procedure ?',
    children: (
      <FAQItem
        items={[
          'No unpaid bills',
          'No shipments in “Litigation”',
          'No products IN_BUSINESS FLAGGED',
          'All BOXes and tablets need to be returned to LivingPackets',
        ]}
      />
    ),
    styles: faqItemsStyles,
  },
];

export const FAQ = () => (
  <Flex
    vertical
    align="flex-start"
    style={{
      width: '100%',
    }}
  >
    <Text strong>FAQ</Text>
    <Collapse
      ghost
      style={{
        width: '100%',
      }}
      expandIconPosition="end"
      items={faqItems}
    />
  </Flex>
);
